import React from 'react';

const Admin = ({ status }) => {
    if(status == "Admin"){
        return(
            <div>
                {/* <button>Approve Proposal</button> */}
            </div>
        )
    }
    else{
        return(
            <div></div>
        )
    }

}

export default Admin;
